import { makeStyles } from "@material-ui/core";

export const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    display: "flex",
    padding: "0",
    maxWidth: "245px",
    backgroundColor: 'rgb(255 255 255 / 70%)',
    alignItems: "center",
    justifyContent: "center",
    [theme.breakpoints.down("xs")]: {
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      backgroundColor: 'rgb(255 255 255 / 70%)',
      boxShadow: "0px 4px 16px rgba(0, 0, 0, 0.15)",
    },
  },

  containerMeusPedidos: {
    [theme.breakpoints.down("sm")]: {
      margin: 0,
      minHeight: 55,
      minWidth: 55,
      maxHeight: 55,
      maxWidth: 55,
      padding: 0,
      borderRadius: '50%'
    },
  },
  textos: {
  },
}));
